/* eslint-disable-next-line no-unused-vars */
import React from 'react';
import { Box, Typography, Container, Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Portrait from '../img/_MG_2223.jpg'

const About = () => {
    const name = "Quinn Peterson"
    const title = "DevOps Engineer @ Visa"

    const handleScrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div id='about'>
            {/* Hero */}
            <Box sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0a0a0a 0%, #0d1b2e 60%, #0a2a4a 100%)',
                display: 'flex',
                alignItems: 'center',
                pt: 8
            }}>
                <Container maxWidth="lg">
                    <Grid container spacing={6} alignItems="center" justifyContent="center">
                        <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{
                                width: { xs: 220, md: 300 },
                                height: { xs: 220, md: 300 },
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '4px solid #007FFF',
                                boxShadow: '0 0 40px rgba(0,127,255,0.3)'
                            }}>
                                <img
                                    src={Portrait}
                                    alt="Portrait of Quinn"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Typography variant="overline" sx={{ color: '#007FFF', letterSpacing: '0.15em', fontSize: '0.85rem' }}>
                                Welcome
                            </Typography>
                            <Typography variant="h2" sx={{ color: 'white', fontWeight: 700, mt: 1, mb: 1, fontSize: { xs: '2rem', md: '3rem' } }}>
                                {name}
                            </Typography>
                            <Typography variant="h5" sx={{ color: '#60aaff', fontWeight: 400, mb: 3 }}>
                                {title}
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.8, mb: 4, maxWidth: 560 }}>
                                DevOps Engineer at Visa working on Platform Enablement — building internal tools that
                                empower engineering teams to move faster and more reliably. I work closely with AI to
                                define new development workflows and drive automation across the platform.
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    onClick={() => handleScrollToSection('projects')}
                                    sx={{
                                        bgcolor: '#007FFF',
                                        px: 3, py: 1.2,
                                        borderRadius: '8px',
                                        fontWeight: 600,
                                        '&:hover': { bgcolor: '#0060CC' }
                                    }}
                                >
                                    View My Work
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => handleScrollToSection('contact')}
                                    sx={{
                                        borderColor: '#007FFF',
                                        color: '#60aaff',
                                        px: 3, py: 1.2,
                                        borderRadius: '8px',
                                        fontWeight: 600,
                                        '&:hover': { borderColor: '#60aaff', bgcolor: 'rgba(0,127,255,0.08)' }
                                    }}
                                >
                                    Contact Me
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* About Me blurb */}
            <Box sx={{ bgcolor: '#f8faff' }}>
                <Container maxWidth="lg" sx={{ py: 8 }}>
                    <Box sx={{
                        borderRadius: '16px',
                        bgcolor: '#007FFF',
                        p: { xs: 3, md: 5 },
                        textAlign: 'center',
                        boxShadow: '0 8px 32px rgba(0,127,255,0.2)'
                    }}>
                        <Typography variant="h4" color='white' fontWeight={700} mb={2}>
                            About Me
                        </Typography>
                        <Typography variant='body1' color='white' sx={{ maxWidth: 700, mx: 'auto', lineHeight: 1.8, opacity: 0.92 }}>
                            I am a DevOps Engineer at Visa working on Platform Enablement, where I build new internal tools that
                            empower engineering teams to move faster and more reliably. I work closely with AI to define new
                            development workflows and drive automation across the platform. I am passionate about cloud infrastructure,
                            developer experience, and continuously finding ways to make complex systems simpler and more efficient.
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </div>
    );
};

export default About;
